<template>
  <div class="first">
    <div class="top" ref="top">
      <a class="image wow fadeInLeft" href="./index.html">
        <img src="../../public/image/logo.png" alt />
      </a>

      <div class="menulist">
        <ul>
          <li :class="{ active: name == 'index' }">
            <a class="title wow fadeInDown" href="./index.html">{{
              $t("list")[0]
            }}</a>
            <a class="sub" href="./index.html">{{ $t("list")[0] }}</a>
          </li>
          <li :class="{ active: name == 'about' }">
            <a
              class="title wow fadeInDown"
              style="animation-delay: 0.2s"
              href="./about.html"
              >{{ $t("list")[1] }}</a
            >
            <a class="sub" href="./about.html">{{ $t("list")[1] }}</a>
          </li>
          <li :class="{ active: name == 'produce' }">
            <a
              class="title wow fadeInDown"
              style="animation-delay: 0.4s"
              href="./produce.html"
              >{{ $t("list")[2] }}</a
            >
            <a class="sub" href="./produce.html">{{ $t("list")[2] }}</a>
          </li>
          <li :class="{ active: name == 'news' }">
            <a
              class="title wow fadeInDown"
              style="animation-delay: 0.6s"
              href="./news.html"
              >{{ $t("list")[3] }}</a>
            <a class="sub" href="./news.html">{{ $t("list")[3] }}</a>
          </li>
          <li :class="{ active: name == 'sale' }">
            <a
              class="title wow fadeInDown"
              style="animation-delay: 0.8s"
              href="./sale.html"
              >{{ $t("list")[4] }}</a
            >
            <a class="sub" href="./sale.html">{{ $t("list")[4] }}</a>
          </li>
          <li :class="{ active: name == 'contact' }">
            <a
              class="title wow fadeInDown"
              style="animation-delay: 1s"
              href="contact.html"
              >{{ $t("list")[5] }}</a
            >
            <a class="sub" href="contact.html">{{ $t("list")[5] }}</a>
          </li>
        </ul>
      </div>
      <div class="icon wow fadeInRight">
          <i class="iconfont icon-sousuo" @click="seachDialog = true"></i>
        <!-- <div class="iconitem">
          <i class="iconfont icon-telephone"></i>
        </div>
        <div class="iconitem">
          <i class="iconfont icon-weibo"></i>
        </div>
        <div class="iconitem">
          <i class="iconfont icon-qq"></i>
        </div> -->
        <div
          class="iconitem eaitem"
          @mouseenter="showLan"
          @mouseleave="HideLan"
        >
          <span>
            <img src="/image/ea.svg" alt="" />
          </span>
<!--          <div class="changeLan" :class="{ lan2: show }">-->
            <p @click="changeLan('zh-CN')" class="lang">中文</p>
            <p @click="changeLan('en')" class="lang">English</p>
<!--          </div>-->
        </div>
      </div>
    </div>
    <div class="searchDialog" :class="{ searchShow: seachDialog }">
      <div class="searchbox">
        <input
          type="text"
          name="search"
          id="search"
          spellcheck="false"
          placeholder="SEARCH"
          v-model = "search"
        />
<!--        <a href="./result.html">-->
          <i class="iconfont icon-sousuo" @click="getSearch()"></i>
<!--        </a>-->
      </div>
      <i class="el-icon-close close" @click="seachDialog = false"></i>
    </div>
    <Pmenu />
  </div>
</template>

<script>
import Pmenu from "../components/pmenu";
import { setup } from "@/local/index";
import { windowWidth, mobileWidth } from "@/util/util";
export default {
  data() {
    return {
      menuindex: 0,
      seachDialog: false,
      show: false,
      search:"",
      list:[],
    };
  },
  components: { Pmenu },
  props: ["name"],
  mounted() {
    const _this = this;
    _this.$nextTick(() => {
      if (windowWidth() > mobileWidth) {
        _this.calcTopHeight();
      }
    });
  },
  methods: {
    getSearch() {
      const link = `./result.html?keyword=` +this.search;
      window.open(link, "_self");
    },
    changeLan(n) {

      this.$i18n.locale = n;
      window.localStorage.setItem("language", n);
      setup(n);
      window.location.reload();
    },
    HideLan() {
      this.show = false;
    },
    showLan() {
      this.show = true;
    },
    calcTopHeight() {
      const topEleHeight = this.$refs.top.clientHeight;
      this.$store.commit("setTopHeight", {
        h: topEleHeight,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.clickClass {
  background: #999999;
  color: #fffdef;
}
.top .icon .iconitem.eaitem{
  width: fit-content;

}
.top .icon .iconitem p{
  height: 40px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.top .icon .iconitem p:nth-child(2){
  margin: 0 10px;
}
.first {
  position: fixed;
  top: 0;
  z-index: 100;
}
.top {
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  align-items: center;
  height: 90px;
  justify-content: space-between;
  background-color: white;
  .image {
    margin-left: 3%;
    img {
      height: 48px;
      display: block;
      object-fit: contain;
    }
  }

  .menulist {
    width: 60%;

    ul {
      display: flex;
      justify-content: center;
      li {
        list-style: none;
        line-height: 90px;
        height: 90px;
        padding: 0 30px;
        position: relative;
        overflow: hidden;
        transition: all 600ms;
        &::after {
          display: inline-block;
          content: "";
          position: absolute;
          bottom: -1px;
          left: 0;
          width: 100%;
          opacity: 0;
          background-color: #008bd5;
          height: 3px;
          // transition: all 100ms;
          border-radius: 5px;
        }
        .sub {
          display: inline-block;
          position: absolute;
          bottom: -90px;
          left: 0;
          width: 100%;
          background-color: #008bd5;
          height: 90px;
          color: white !important;
          text-align: center;
          transition: all 600ms;
          opacity: 0;
        }
        &:hover {
          .title {
            color: #008bd5;
            transform: translateY(-100px);
          }
          .sub {
            bottom: 0;
            opacity: 1;
          }
          &::after {
            opacity: 1;
          }
        }
        .title {
          color: #333333;
          font-size: 16px;
          font-family: "SOURCEHANSANSCN-NORMAL";
          transition: all 600ms;
          display: inline-block;
        }
      }
      .active {
        .title {
          color: #008bd5;
        }
        &::after {
          opacity: 1;
        }
      }
    }
  }
  .icon {
    margin-right: 3%;
    display: flex;
    align-items: center;
    .icon-sousuo {
      font-size: 30px;
      color: #999999;
      margin-right: 16px;
      cursor: pointer;
      transition: all 300ms;
      &:hover {
        color: #008bd5;
      }
    }
    .iconitem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 50%;
      width: 155px;
      height: 30px;
      border: 1px solid #999999;
      position: relative;
      margin-left: 14px;
      cursor: pointer;
      p {
        color: #999999;
      }
      &.eaitem {
        border-color: transparent;
        img {
          width: 32px;
          animation: rotate infinite 8s linear;
        }
      }
      @keyframes rotate {
        from {
          transform: rotate(0);
        }
        to {
          transform: rotate(360deg);
        }
      }
      .changeLan {
        position: absolute;
        left: 0;
        top: 40px;
        margin-left: -30px;
        cursor: pointer;
        width: 100px;
        background-color: #084cad;
        border-radius: 5px;
        padding-bottom: 5px;
        transition: all 600ms;
        transform: scale(0);
        p {
          text-align: center;
          font-size: 12px;
          font-weight: lighter;
          color: white;
          padding-top: 5px;
        }
      }
      span {
        display: inline-block;
      }
      .lan2 {
        transform: scale(1);
      }
      i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 22px;
        color: #999999;
        transition: all 600ms;
        &:hover {
          color: #008cd6;
        }
      }
    }
  }
}

.searchDialog {
  // display: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  top: -200px;
  width: 100%;
  background-color: white;
  height: 90px;
  // transition: all 300ms;
  .searchbox {
    width: 80%;
    margin: auto;
    input {
      width: 95%;
      line-height: 30px;
      margin-top: 3%;
      height: 20px;
      border: none;
      outline: none;
      border-bottom: 1px solid #cccccc;
      background-color: rgba(0, 0, 0, 0);
      &::-webkit-input-placeholder {
        color: #cccccc;
      }
      color: #333333;
    }
    i {
      position: relative;
      top: -18px;
      left: 98%;
      cursor: pointer;
      // color: #cccccc;
      font-size: 20px;
      transition: all 300ms;
      &:hover {
        color: #008cd6;
      }
    }
  }
  .close {
    cursor: pointer;
    position: absolute;
    top: 48%;
    right: -0.5%;
    transform: translateY(-50%);
    transition: all 300ms;
    &:hover {
      color: #008cd6;
    }
  }
}
.searchShow {
  top: 0;
  width: 18%;
  margin-left: 69%;
}
@media screen and (max-width: 1000px) {
  .top {
    display: none;
  }
}
</style>
